import { createAction, createSlice } from '@reduxjs/toolkit';
import { ClientState, VoterEntityState } from '../../_generatedTypes.g';

export const innerStateSet = createAction<ClientState>('SET_INNER_STATE_NEW');
export const panicStateSet = () => innerStateSet({ Type: 'PANIC_STATE' } as ClientState);
export const loadingStateSet = () => innerStateSet({ Type: 'LOADING_STATE' } as ClientState);
export const voterEntityStateRefreshed = createAction<VoterEntityState>('VOTER_ENTITY_STATE_REFRESH');


const clientStateSlice = createSlice({
    name: 'SLICE_clientState',
    initialState: {} as ClientState | null,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(innerStateSet, (state, action) => {
            if (action.payload.Type === 'LOGGED_IN_STATE' || action.payload.Type === 'LOGGED_OUT_STATE') {
                return action.payload;
            } else {
                return null;
            }
        })
    }
});

export default clientStateSlice.reducer
